


















import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'Footer',
})
/**
 * @vuese
 * @group Atomic/Organisms
 * footter
 */
export default class Footer extends Vue {}
